// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"0bee0d54","787":"5b877174"}[chunkId] + ".chunk.js";
};